import {
  SET_NAVBAR_NOTIFICATIONS,
  FETCH_NOTIFICATIONS,
  TOGGLE_UNREAD_FILTER,
  SET_FILTERED_TYPES,
  TOGGLE_READ_FILTER,
  INCREASE_LIMIT,
  SET_TOTAL_NOTIFICATIONS,
  REMOVE_COURSE_FROM_NAVBAR_NOTIFICATIONS,
} from './constants'

const initialState = {
  navbarNotifications: [],
  notifications: [],
  readFilter: false,
  filteredTypes: [],
  limit: 50,
  totalNotifications: 0,
}

const notificationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_NAVBAR_NOTIFICATIONS:
      return {
        ...state,
        navbarNotifications: action.payload,
      }
    case FETCH_NOTIFICATIONS:
      return {
        ...state,
        notifications: action.payload,
      }
    case TOGGLE_UNREAD_FILTER:
      return {
        ...state,
        readFilter: false,
        unreadFilter: !state.unreadFilter,
      }
    case TOGGLE_READ_FILTER:
      return {
        ...state,
        unreadFilter: false,
        readFilter: !state.readFilter,
      }
    case SET_FILTERED_TYPES:
      return {
        ...state,
        filteredTypes: action.payload,
      }
    case SET_TOTAL_NOTIFICATIONS:
      return {
        ...state,
        totalNotifications: action.payload,
      }
    case INCREASE_LIMIT:
      return {
        ...state,
        limit: state.limit + 50,
      }

    case REMOVE_COURSE_FROM_NAVBAR_NOTIFICATIONS: {

      const newNotifications = state.navbarNotifications.filter((n) => {
        try {
          const courseId = JSON.parse(n.data).course_id
          const keep = String(courseId) !== String(action.payload)
          return keep
        } catch (err) {
          return true
        }
      })

      return {
        ...state,
        navbarNotifications: newNotifications,
      }
    }

    default:
      return state
  }
}

export default notificationReducer
